<script setup lang="ts">
import { formatRelativeTime } from '@/utils/status';
import { computed } from 'vue';
import { statusMessages } from '@/i18n';

const props = defineProps<{
  lastUpdated: Date | null;
}>();

const relative = computed(() => formatRelativeTime(props.lastUpdated));
</script>

<template>
  <footer class="site-footer">
    <span>{{ statusMessages.footerRefresh(relative) }}</span>
    <span>
      {{ statusMessages.poweredBy }} &middot;
      <a href="https://xtrakt.ai" target="_blank" rel="noopener noreferrer">xtrakt.ai</a>
    </span>
  </footer>
</template>

<style scoped>
.site-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid var(--xt-border-subtle);
  font-size: 0.8rem;
  color: var(--xt-fg-muted);
}

.site-footer a {
  color: var(--xt-fg-link);
  text-decoration: none;
}

.site-footer a:hover {
  text-decoration: underline;
}
</style>
